import 'whatwg-fetch'

export default class FormAttributeApiService {

  constructor(rails_authenticity_token){
    this.rails_authenticity_token = rails_authenticity_token;
  }

  getFormAttribute(faId, keenformId){
    return window.fetch(`/dashboard/keenforms/${keenformId}/form_attributes/${faId}.json`, {
      method: 'GET'
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(formAttribute) {
      return formAttribute;
    })
    .catch(function(error) {
      console.log(error);
    });
  }

  createFormAttribute(keenformId, formAttributeData){
    let params = {
      authenticity_token: this.rails_authenticity_token,
      form_attribute: formAttributeData
    };
    console.log(params);
    return window.fetch(`/dashboard/keenforms/${keenformId}/form_attributes/`, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(formAttribute) {
      return formAttribute;
    })
    .catch(function(error) {
      console.log('something failed');
      console.log(error);
    });
  }

  createFormAttributeWithDefaults(keenformId, formAttributeData){
    const formAttributeVals = {...formAttributeData};
    formAttributeVals.with_defaults = true;
    return this.createFormAttribute(keenformId, formAttributeVals);
  }

  deleteFormAttribute(faId, keenformId){
    let params = {
      authenticity_token: this.rails_authenticity_token,
    };
    return window.fetch(`/dashboard/keenforms/${keenformId}/form_attributes/${faId}.json`, {
      method: 'DELETE',
      body: JSON.stringify(params),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then( (response) => {
      //TODO: check response.ok to determine what happened, handle differently for error
      return response.json();
    })
    .then((response) => {
      return response;
    })
    .catch(function(error) {
      console.log('something failed');
      console.log(error);
      return error;
    });
  }

  getFormAttributeObject(keenform_id = null){
    return {
      id: null,
      deleteable: true,
      keenform_id: keenform_id || null,
      name: null,
      label: null,
      form_attribute_type: null,
      value_type: "text",
      display_type: "text",
      position: null,
      required: false,
      hidden: false,
      read_only: false
    }
  }

  getNewFormAttributeObjectWithDefaults(keenform_id, faType = undefined){
    let newFormAttribute = this.getFormAttributeObject(keenform_id);
    delete newFormAttribute.id;
    newFormAttribute.display_type = (!!faType ? faType : newFormAttribute.display_type);
    newFormAttribute.new = true;
    return newFormAttribute;
  }

  getKeenformById(keenformId){
    return window.fetch(`/dashboard/keenforms/${keenformId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(formAttribute) {
      return formAttribute;
    })
    .catch(function(error) {
      console.log('something failed');
      console.log(error);
    });
  }

  reorderFormAttributes(keenformId, formAttributes){
    const updatedFAObj = {};
    formAttributes.forEach( (fa, index) => {
      updatedFAObj[index.toString()] = {
        id: fa.id,
        position: fa.position,
        keenform_id: keenformId
      }
    })
    const params = {
      authenticity_token: this.rails_authenticity_token,
      keenform: {
        form_attributes_attributes: updatedFAObj
      }
    };
    const updateKeenformUrl = `/dashboard/keenforms/${keenformId}`;
    return window.fetch(updateKeenformUrl, {
      method: 'PUT',
      body: JSON.stringify(params),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(response) {
      // console.log(response);
      return response;
    })
    .catch( (error) => {
      console.log('error occurred in api service');
      console.log(error);
    })
  }

  updateFormAttribute(faId, keenformId, formAttributeData){
    let params = {
      authenticity_token: this.rails_authenticity_token,
      form_attribute: formAttributeData
    };
    const updateFormAttributeUrl = `/dashboard/keenforms/${keenformId}/form_attributes/${faId}`;
    return window.fetch(updateFormAttributeUrl, {
        method: 'PUT',
        body: JSON.stringify(params),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(formAttribute) {
        return formAttribute;
      })
      .catch( (error) => {
        console.log('error occurred in api service');
        console.log(error);
      })
  }

}